import React from 'react'

const Partners = () => {
    return (
        <div> 
             {/* <!-- Partners strat --> */}
            <div className="partners">
                <div className="container">
                    <div className="slick-slider-area">
                        <div className="row slick-carousel" data-slick='{"slidesToShow": 3, "responsive":[{"breakpoint": 1024,"settings":{"slidesToShow": 3}}, {"breakpoint": 768,"settings":{"slidesToShow": 2}}]}'>
                            <div className="slick-slide-item"><img src="https://firebasestorage.googleapis.com/v0/b/wti-services-jrz.appspot.com/o/partner-01.png?alt=media&token=e6be54b7-e72f-4d62-bb54-0643935a5e26" alt="brand" className="img-fluid"/></div>
                            <div className="slick-slide-item"><img src="https://firebasestorage.googleapis.com/v0/b/wti-services-jrz.appspot.com/o/partner-03.png?alt=media&token=e9823b7c-8fff-4179-9ed2-5e2d74a078de" alt="brand" className="img-fluid"/></div>
                            <div className="slick-slide-item"><img src="https://firebasestorage.googleapis.com/v0/b/wti-services-jrz.appspot.com/o/partner-02.png?alt=media&token=a8e328e5-e881-47da-b137-34d35b31fcc3" alt="brand" className="img-fluid"/></div>
                        
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- Partners end --> */}            
        </div>
    )
}

export default Partners


// WEBPACK FOOTER //
// ./src/components/Partners.jsx